import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Fastboot from "./components";

import ElementUI from "element-ui";
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import { Message, Loading } from "element-ui";
import "./theme/index.css";
import "./icons";
import dict from "@/config/dict"

// Vue.use(ElementUI);

import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "zh", // 语言标识
  messages: {
    zh: Object.assign(require("./lang/zh.json"), zhLocale),
    en: Object.assign(require("./lang/en.json"), enLocale),
  }
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

import axios from "axios";
import qs from "qs";
import md5 from "md5";
import moment from "moment"
import api from "./config/api";
import filters from "./utlis/filters";

Object.keys(filters).map(v => {
  Vue.filter(v, filters[v]);
});

import {CustomLoading} from "./utlis/loading";
const loading = new CustomLoading(Loading);

Vue.prototype.$api = api;
Vue.prototype.$http = axios;
Vue.prototype.$md5 = md5;
Vue.prototype.$qs = qs;
Vue.prototype.$moment = moment;
Vue.prototype.$bus = new Vue();
Vue.prototype.$customLoading = loading;
Vue.prototype.$dict = dict;
axios.defaults.withCredentials = true;



//路由拦截器
router.beforeEach((to, form, next) => {
  loading.hideLoading();
  let routerList = ["/set-password", "/login", '/h5/index.html'];
  if (
    !sessionStorage.getItem("login-user-info") &&
    !routerList.includes(to.path)
  ) {
    next("/login");
  } else {
    next();
  }
});
Vue.use(Fastboot);

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");


Vue.prototype.$http.interceptors.response.use(
    resp => {
      //如果未授权，则跳转至授权页面
      if (resp.data.status === 401) {
        if (sessionStorage.getItem("login-user-info") != null) {
          // Message.warning("30分钟未操作自动退出登录");
        }

        sessionStorage.removeItem("login-user-info");

        router.push("/login");
      }

      //如果未授权，则跳转至授权页面
      if (resp.data.status === 403) {
        router.push("/no-permission");
      }

      if(resp.data.desc === "操作成功！" && resp.data.desc === "操作成功") {
        resp.data.desc =  i18n.t('lang.操作成功');
      }
      return resp;
    },
    error => {
      let { response: res } = error;
      if (res.status === 500 && res.data.message === "您未登录") {
        let message = res.data.message;
        message = i18n.t('lang.' + message);
        Message.error(message);
        sessionStorage.removeItem("login-user-info");
        router.push("/login");
      }

      return Promise.reject(error);
    }
);
